import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currency',
  standalone: true
})
export class CurrencyPipe implements PipeTransform {

  transform(s: string | null, format:boolean = true): string {
    
    if(s == null) return '';

    let n = s.toString().replace(/\D/g, '').padEnd(3, '0')
    // console.warn('CurrencyFormatPipe -> transform', 's', s, 'n', n) 

    let nInteger = n.substring(0, n.length-2)
    // console.error('PercentageDirective -> nInteger', 'nInteger', nInteger)
    if(n.length < 1 || nInteger.length == 0)
      nInteger = '0'
    // console.error('PercentageDirective -> nInteger', 'nInteger', nInteger)

    const nDecimal = n.substring(n.length-2)
    const value = parseInt(nInteger).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace(',00', `,${nDecimal}`)

    console.warn('CurrencyFormatPipe -> transform', 'nInteger', nInteger, 'nDecimal', nDecimal, 'value', value, 'number', parseFloat(nInteger + '.' + nDecimal))

    if (format)
      return value
    else 
      return (nInteger + '.' + nDecimal)
  }

}
